import { type ComponentPropsWithRef, memo } from 'react';

export const IconForYou = (props: ComponentPropsWithRef<'svg'>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.09467 3.09467C4.42914 1.7602 6.42603 1.25 9 1.25H15C17.574 1.25 19.5709 1.7602 20.9053 3.09467C22.2398 4.42914 22.75 6.42603 22.75 9V15C22.75 17.574 22.2398 19.5709 20.9053 20.9053C19.5709 22.2398 17.574 22.75 15 22.75H9C6.42603 22.75 4.42914 22.2398 3.09467 20.9053C1.7602 19.5709 1.25 17.574 1.25 15V9C1.25 6.42603 1.7602 4.42914 3.09467 3.09467ZM4.15533 4.15533C3.2398 5.07086 2.75 6.57397 2.75 9V15C2.75 17.426 3.2398 18.9291 4.15533 19.8447C5.07086 20.7602 6.57397 21.25 9 21.25H15C17.426 21.25 18.9291 20.7602 19.8447 19.8447C20.7602 18.9291 21.25 17.426 21.25 15V9C21.25 6.57397 20.7602 5.07086 19.8447 4.15533C18.9291 3.2398 17.426 2.75 15 2.75H9C6.57397 2.75 5.07086 3.2398 4.15533 4.15533Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.173 7.72231C11.4644 8.01666 11.462 8.49153 11.1677 8.78296C9.86687 10.0709 7.76401 10.0747 6.46967 8.78033C6.17678 8.48744 6.17678 8.01256 6.46967 7.71967C6.76256 7.42678 7.23744 7.42678 7.53033 7.71967C8.23599 8.42533 9.39313 8.4291 10.1123 7.71704C10.4067 7.42561 10.8815 7.42797 11.173 7.72231Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.5331 7.72231C17.8245 8.01666 17.8221 8.49153 17.5278 8.78296C16.227 10.0709 14.1241 10.0747 12.8298 8.78033C12.5369 8.48744 12.5369 8.01256 12.8298 7.71967C13.1227 7.42678 13.5975 7.42678 13.8904 7.71967C14.5961 8.42533 15.7532 8.4291 16.4724 7.71704C16.7668 7.42561 17.2416 7.42797 17.5331 7.72231Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.4 13.75C8.31421 13.75 8.25 13.8142 8.25 13.9C8.25 15.9758 9.92421 17.65 12 17.65C14.0758 17.65 15.75 15.9758 15.75 13.9C15.75 13.8142 15.6858 13.75 15.6 13.75H8.4ZM6.75 13.9C6.75 12.9858 7.48579 12.25 8.4 12.25H15.6C16.5142 12.25 17.25 12.9858 17.25 13.9C17.25 16.8042 14.9042 19.15 12 19.15C9.09579 19.15 6.75 16.8042 6.75 13.9Z"
			fill="#111111"
		/>
	</svg>
);

export const IconForYouActive = memo<ComponentPropsWithRef<'svg'>>((props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM6.47 7.72C6.76 7.43 7.24 7.43 7.53 7.72C8.24 8.43 9.4 8.43 10.11 7.72C10.4 7.43 10.88 7.43 11.17 7.72C11.46 8.01 11.46 8.49 11.17 8.78C10.52 9.43 9.67 9.75 8.82 9.75C7.97 9.75 7.12 9.43 6.47 8.78C6.18 8.48 6.18 8.01 6.47 7.72ZM12 18.78C9.31 18.78 7.12 16.59 7.12 13.9C7.12 13.2 7.69 12.62 8.39 12.62H15.59C16.29 12.62 16.86 13.19 16.86 13.9C16.88 16.59 14.69 18.78 12 18.78ZM17.53 8.78C16.88 9.43 16.03 9.75 15.18 9.75C14.33 9.75 13.48 9.43 12.83 8.78C12.54 8.49 12.54 8.01 12.83 7.72C13.12 7.43 13.6 7.43 13.89 7.72C14.6 8.43 15.76 8.43 16.47 7.72C16.76 7.43 17.24 7.43 17.53 7.72C17.82 8.01 17.82 8.48 17.53 8.78Z"
			fill="#101010"
		/>
	</svg>
));
